import React, { useEffect, useState } from 'react';
import { ChakraProvider, Box, SystemContext } from '@chakra-ui/react';
import { chakraUiTheme, ColorModeProvider } from '@everfi/design-system';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { AlertToaster } from '../core/hooks/AlertToaster';

interface Props {
  children?: React.ReactNode;
  theme?: SystemContext;
}

export const ChakraUIProvider: React.FC<Props> = ({ children, theme = chakraUiTheme }) => {
  // The first render has no Chakra context so published react_on_rails consumers hydrate against matching SSR
  // markup. HAZARD: a Chakra component rendered on it, outside a Chakra-free Suspense, throws a ContextError.
  const [oneRender, setOneRender] = useState(false);
  useEffect(() => setOneRender(true), []);
  const serverSide = typeof window === 'undefined';

  if (serverSide || !oneRender) {
    const cache = createCache({ key: 'custom' });
    return <CacheProvider value={cache}>{children}</CacheProvider>;
  }

  return (
    <ChakraProvider value={theme}>
      <ColorModeProvider>
        <Box>{children}</Box>
        <AlertToaster />
      </ColorModeProvider>
    </ChakraProvider>
  );
};
